import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExportService } from '../../../../services/export.csv.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { HubExportPdfStore } from '../../../../stores/hub.calendar.store';
import { EditTourTitleModalActions, EditTourTitleModalData } from './edit.tour.title.modal.provider';
import { BaseComponent } from '../../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../../common/components';

@Component({
    templateUrl: './edit.tour.title.modal.component.html',
    styleUrls: ['./edit.tour.title.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EditTourTitleModalComponent extends BaseComponent {

    public data: EditTourTitleModalData;
    public hubName: string;
    public editTourTitleFormGroup: FormGroup;

    constructor(private dialogRef: MatDialogRef<EditTourTitleModalComponent>,
                private actions: EditTourTitleModalActions,
                private hubApiService: HubApiService,
                private exportService: ExportService,
                private formBuilder: FormBuilder,
                private exportPdfStore: HubExportPdfStore,
                data: EditTourTitleModalData) {
        super();
        this.data = Object.assign({}, data);

        this.editTourTitleFormGroup = this.formBuilder.group({
            'title': [null, [Validators.required]],
            'description': [null, []]
        });
    }

    public close(): void {
        if (this.actions.cancel) {
            this.actions.cancel();
        }

        this.dialogRef.close();
    }

    public confirm(event: ButtonTriggerEvent) {
        if (this.data.isAsync) {
            let oldFunc = event.complete;
            event.complete = () => {
                oldFunc();

                this.dialogRef.close();
            };
            this.hubApiService.updateTourTitleAndDescription(
                this.data.hubName, this.data.id, this.data.title, this.data.description)
                .subscribe(() => {
                    this.actions.confirm(event, this.data.title, this.data.description);
                    event.complete();
                });
        } else {
            this.actions.confirm(event, this.data.title, this.data.description);
            this.dialogRef.close();
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/edit.tour.title.modal/edit.tour.title.modal.component.ts